// extracted by mini-css-extract-plugin
export default {"tab_section_main_div":"DesignBoxTabSection_tab_section_main_div__ToHV7","tab_section_button":"DesignBoxTabSection_tab_section_button__0uv+6"};